import type { IconProps } from '../types/IconProps.ts';
export const Chat: IconProps = {
    name: 'Chat',
    children: [
        `<path d="M2 6c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v9.3a2 2 0 0 1-2 2H7.66a2 2 0 0 0-1.19.4L2.8 20.4A.5.5 0 0 1 2 20zM6 8h11M6 13h9" />`,
    ]
};